// Module 6: Final Report Generator.
// Receives all prior outputs and produces the regulator-ready report text.

export function buildReportMessage({
  facts,
  qaText,
  redFlagsText,
  defensibilityText,
  scoring,
  fileName,
}) {
  return `Customer file under review: ${fileName || 'untitled'}

--- EXTRACTED FACTS (JSON) ---
${JSON.stringify(facts, null, 2)}

--- KYC QA ASSESSMENT ---
${qaText}

--- RED FLAGS ---
${redFlagsText}

--- DEFENSIBILITY ASSESSMENT ---
${defensibilityText}

--- SCORE AND DECISION (JSON) ---
${JSON.stringify(scoring, null, 2)}

--- END INPUTS ---

Now write the final regulator-ready QA report using the exact section headings in your instructions. Do not invent regulatory citations: use only references that appeared in the inputs above.`;
}
